<section class="filtered-search-container ac-dropdown full-width">
	<input
		class="search-input"
		placeholder="{{ searchDescription }}"
		[(ngModel)]="searchInput"
		(ngModelChange)="searchInputChanged($event)"
		(focus)="onFocus()"
		(blur)="onBlur()"
		data-cy="elements-filter-dropdown"
	/>
	<ac-dropdown-options
		*ngIf="isInputFocused || isDropdownHovered"
		[title]="title"
		[filteredItems]="isGroupedDropdown ? filteredItemsMap : filteredItems"
		[isGroupedDropdown]="isGroupedDropdown"
		[browseButtonInformation]="browseButtonInformation"
		(onHover)="onHover($event)"
		(onSelection)="onSelection($event)"
	></ac-dropdown-options>
</section>
